import { FileListItem } from "../Components/fileList/fileList"
import { DischargeLenderItem, LenderContactType, MortgageLenderItem } from "../Components/MortgageLender/MortgageLenderTypes";
import { lddGlobalSessionInfo, lddGlobalSessionUserInfo } from "../Components/navigationTypes";
import { ThirdPartyListItem } from "../Components/ThirdPartyList/ThirdPartyTypes";
import { FormListItem } from "../docservice/Components/List/ListFuncs";
import { deepCopy } from "./xmlFuncs";

type convertXMLOutputType = "FormListItem" |
    "FileListItem" |
    "lddGlobalSessionInfo" |
    "lddGlobalSessionUserInfo" |
    "ThirdPartyListItem" |
    "MortgageLenderItem" |
    "LenderContactType" |
    "DischargeLenderItem";
type ObjectType<T> =
    T extends "FormListItem" ? FormListItem :
    T extends "FileListItem" ? FileListItem :
    T extends "lddGlobalSessionInfo" ? lddGlobalSessionInfo :
    T extends "lddGlobalSessionUserInfo" ? lddGlobalSessionUserInfo :
    T extends "ThirdPartyListItem" ? ThirdPartyListItem :
    T extends "MortgageLenderItem" ? MortgageLenderItem :
    T extends "LenderContactType" ? LenderContactType :
    T extends "DischargeLenderItem" ? DischargeLenderItem :
    never

export function importJSON<T extends convertXMLOutputType>(jsonData, initObj: ObjectType<T>): ObjectType<T> {
    const record: ObjectType<T> = deepCopy(initObj)
    for (let key in record) {
        if (jsonData[key]) {
            record[key] = jsonData[key]
        }
    }
    return record;
}